module.exports = __webpack_public_path__ + "static/img/product07-4.41118cc6.png";